<template>
  <i
    class="z-icon"
    :class="'z-icon--' + type"
    :style="{
      width: size + 'px',
      height: size + 'px'
    }"
  ></i>
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'default'
      },

      size: {
        type: [String, Number],
        default: 32
      }
    }
  };
</script>

<style lang="scss">
  .z-icon {
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100%;

    &--default {
      background-image: url('/img/icons/notifications/default.svg');
    }

    &--info {
      background-image: url('/img/icons/notifications/info.svg');
    }

    &--danger,
    &--error {
      background-image: url('/img/icons/notifications/danger.svg');
    }

    &--success {
      background-image: url('/img/icons/notifications/success.svg');
    }

    &--warning {
      background-image: url('/img/icons/notifications/warning.svg');
    }
  }
</style>
